module.exports = __webpack_public_path__ + "@/assets/img/at.998f6391.svg";